import React from "react";
import { Icon } from "@iconify/react";

const CompanyViewIcon = () => (
  <Icon icon="lucide:building-2" width={18} height={18} />
);

export default CompanyViewIcon;
